function getFadeUpTween(delay = 0) {
  return {
    opacity: 0,
    y: 8,
    delay
  }
}

function getYAxisTween(delay = 0) {
  return {
    opacity: 0,
    x: -8,
    delay
  }
}

function getLineDrawTween(delay = 0) {
  return {
    strokeDashoffset: 0,
    delay,
    ease: Power2.easeIn
  }
}

function getScaleUpTween(delay = 0) {
  return {
    scaleY: 0,
    transformOrigin: 'left bottom',
    delay,
    ease: Power2.easeIn
  }
}

const runwayChart = document.getElementById('dashboard-runway-chart');
const totalRevChart = document.getElementById('dashboard-total-revenue-chart');
const totalExpensesChart = document.getElementById('dashboard-total-expenses-chart');
const deptExpensesChart = document.getElementById('dashboard-dept-expenses-chart');
const payrollChart = document.getElementById('dashboard-payroll-chart');
const growthRateChart = document.getElementById('growth-rate-chart');
const mrrChart = document.getElementById('dashboard-mrr-chart');

const calloutCellCoords = document.getElementById('spreadsheet-cell-highlight').getBBox()
const spreadsheetCallout = document.getElementById('spreadsheet-callout')
const dashboard = document.getElementById('hero-dashboard-graphic')
const dashboardCoords = dashboard.getBoundingClientRect();
const mrrChartCoords = mrrChart.getBoundingClientRect();
const mrrChartX = mrrChartCoords.x - dashboardCoords.x;
const mrrChartY = mrrChartCoords.y - dashboardCoords.y;

new TweenLite(dashboard, 0, {
  x: -mrrChartX - 4,
  y: -mrrChartY,
  scale: 2.15,
  opacity: 1
})

const dashboardMrrLine = document.getElementById('dashboard-mrr-line')
const mrrLinePath = dashboardMrrLine.getAttribute('d')
dashboardMrrLine.setAttribute(
  'd',
  'M597 732.25L635 732.25L670.5 732.25L708.5 732.25L745 732.25L783.5 732.25L821 732.25L859.5 732.25L896 732.25L933.5 732.25L972.5 732.25'
)
const mrrChartBbox = mrrChart.getBBox();
const mrrLineCoords = dashboardMrrLine.getBBox();
const mrrLineX = mrrLineCoords.x - mrrChartBbox.x;
const mrrLineY = mrrLineCoords.y - mrrChartBbox.y;

const chartLines = [...dashboard.querySelectorAll('.base-line'), ...dashboard.querySelectorAll('.compare-line')];
chartLines.forEach((line) => {
  const length = line.getTotalLength()
  line.style.strokeDasharray = length
  line.style.strokeDashoffset = length
});

const expensesColumns = [
  ...totalExpensesChart.querySelectorAll('.base, .compare'),
  ...deptExpensesChart.querySelectorAll('.base, .compare'),
];
expensesColumns.forEach(({ children }) => {
  [...children].forEach((segment, idx) => {
    segment.style.fillOpacity = 1 - (1 / children.length * idx);
  });
});

const { x, y, width, height } = spreadsheetCallout.getBBox()

const calloutTween = new TimelineMax()
  .to(dashboard.querySelectorAll('.base-dot, .compare-dot'), 0, {
    scale: 0,
    transformOrigin: 'center',
  })
  .to(dashboardMrrLine, 0, {
    x: calloutCellCoords.x / 2.15 - mrrLineX - 3.5,
    y: calloutCellCoords.y / 2.15 - mrrLineY - 76,
    opacity: 0,
    scaleX: 0.16,
    strokeWidth: 22.5,
  })
  .to(
    ['#spreadsheet-callout-shadow', '#spreadsheet-callout-text', '#spreadsheet-callout-zoom'],
    0.3,
    { opacity: 0, ease: Power2.easeIn },
    0
  )
  .to('#spreadsheet-cursor', 0.3, { opacity: 0 }, 0)
  .to(
    spreadsheetCallout,
    0.5,
    {
      x: calloutCellCoords.x - x,
      y: calloutCellCoords.y - y,
      scaleX: calloutCellCoords.width / width,
      scaleY: calloutCellCoords.height / (height - 8),
      ease: Power2.easeIn,
    },
    0
  )
  .to(dashboardMrrLine, 0, { opacity: 1, delay: 0.49 }, 0)
  .to(dashboardMrrLine, 0.3, { x: -71, scaleX: 1.3, delay: 0.49, ease: Power1.easeIn }, 0)
  .to([spreadsheetCallout, '#spreadsheet-backdrop', '#spreadsheet-cell-highlight'], 0.5, { opacity: 0 }, 1)
  .to(
    dashboardMrrLine,
    0.5,
    {
      attr: { d: mrrLinePath },
      ease: Power2.easeIn,
    },
    1
  )
  .to(dashboardMrrLine, 0.4, {
    x: 0,
    y: 0,
    scaleX: 1,
    strokeWidth: 1.5,
    strokeLinecap: 'round',
  })
  .staggerFrom(
    mrrChart.querySelectorAll('.x-axis'),
    0.2,
    {
      opacity: 0,
      y: 8,
    },
    0.05
  )
  .staggerFrom(mrrChart.querySelectorAll('.y-axis'), 0.2, getYAxisTween(), 0.05, 2)
  .to('#dashboard-mrr-line2', 1, getLineDrawTween(), 2)
  .staggerFrom(mrrChart.querySelectorAll('.details'), 0.6, getFadeUpTween(), 0.15, 2)
  .fromTo(mrrChart.querySelector('.backdrop'), 0.9, { fillOpacity: 0 }, { fillOpacity: 1 })
  .to([dashboard, dashboardMrrLine], 2, { x: 0, y: 0, scale: 1, ease: Power2.easeIn }, 3)

  .staggerFrom(payrollChart.querySelectorAll('.x-axis'), 0.2, getFadeUpTween(1), 0.05, 3)
  .staggerFrom(payrollChart.querySelectorAll('.y-axis'), 0.2, getYAxisTween(1.4), 0.05, 3)
  .staggerFrom(payrollChart.querySelectorAll('.y-axis-2'), 0.2, { x: 8, opacity: 0, delay: 1.4 }, 0.05, 4)
  .staggerFrom(payrollChart.querySelectorAll('.base'), 0.9, getScaleUpTween(1), 0.075, 3)
  .staggerTo(
    [payrollChart.querySelector('.base-line'), payrollChart.querySelector('.compare-line')],
    0.9,
    getLineDrawTween(1.15),
    0.2,
    4
  )
  .staggerTo(payrollChart.querySelectorAll('.base-dot'), 0.9, { scale: 1, delay: 1.25, ease: Power2.easeIn }, 0.075, 3)
  .staggerFrom(payrollChart.querySelectorAll('.compare'), 0.9, getScaleUpTween(1.25), 0.075, 3)
  .staggerTo(
    payrollChart.querySelectorAll('.compare-dot'),
    0.9,
    { scale: 1, delay: 1.35, ease: Power2.easeIn },
    0.075,
    4
  )
  .staggerFrom(
    payrollChart.querySelectorAll('.dashboard-axis-title, .dashboard-axis-title-2'),
    0.6,
    { opacity: 0, delay: 1.55 },
    0.15,
    3
  )
  .staggerFrom(payrollChart.querySelectorAll('.details'), 0.6, getFadeUpTween(1.75), 0.15, 3)

  .staggerFrom(deptExpensesChart.querySelectorAll('.x-axis'), 0.2, getFadeUpTween(1.45), 0.05, 3)
  .staggerFrom(deptExpensesChart.querySelectorAll('.y-axis'), 0.2, getYAxisTween(1.55), 0.05, 3)
  .staggerFrom(deptExpensesChart.querySelectorAll('.base'), 0.9, getScaleUpTween(1.35), 0.075, 3)
  .staggerFrom(deptExpensesChart.querySelectorAll('.compare'), 0.9, getScaleUpTween(1.55), 0.075, 3)
  .staggerFrom(deptExpensesChart.querySelectorAll('.details'), 0.6, getFadeUpTween(1.9), 0.15, 3)

  .staggerFrom(totalRevChart.querySelectorAll('.x-axis'), 0.2, getFadeUpTween(1.75), 0.05, 3)
  .staggerFrom(totalRevChart.querySelectorAll('.y-axis'), 0.2, getYAxisTween(1.85), 0.05, 3)
  .staggerTo(
    [totalRevChart.querySelector('.base-line'), totalRevChart.querySelector('.compare-line')],
    0.9,
    getLineDrawTween(1.75),
    0.2,
    4
  )
  .staggerFrom(totalRevChart.querySelectorAll('.details'), 0.9, getFadeUpTween(1.95), 0.15, 3)

  .staggerTo(
    [growthRateChart.querySelector('.base-line'), growthRateChart.querySelector('.compare-line')],
    0.9,
    getLineDrawTween(1.7),
    0.2,
    4
  )
  .staggerFrom(growthRateChart.querySelectorAll('.x-axis'), 0.2, getFadeUpTween(1.95), 0.05, 3)
  .staggerFrom(growthRateChart.querySelectorAll('.y-axis'), 0.2, getYAxisTween(1.95), 0.05, 3)
  .staggerFrom(growthRateChart.querySelectorAll('.details'), 0.6, getFadeUpTween(1.95), 0.15, 3)

  .staggerFrom(totalExpensesChart.querySelectorAll('.x-axis'), 0.2, getFadeUpTween(1.9), 0.05, 3)
  .staggerFrom(totalExpensesChart.querySelectorAll('.y-axis'), 0.2, getYAxisTween(2), 0.05, 3)
  .staggerFrom(totalExpensesChart.querySelectorAll('.base'), 0.9, getScaleUpTween(1.85), 0.075, 3)
  .staggerFrom(totalExpensesChart.querySelectorAll('.compare'), 0.9, getScaleUpTween(2), 0.075, 3)
  .staggerFrom(totalExpensesChart.querySelectorAll('.details'), 0.6, getFadeUpTween(1.9), 0.15, 3)

  .staggerFrom(runwayChart.querySelectorAll('.x-axis'), 0.2, getFadeUpTween(2.1), 0.05, 3)
  .staggerFrom(runwayChart.querySelectorAll('.y-axis'), 0.2, getYAxisTween(2.2), 0.05, 3)
  .staggerTo(
    [runwayChart.querySelector('.base-line'), runwayChart.querySelector('.compare-line')],
    0.9,
    getLineDrawTween(1.95),
    0.2,
    4
  )
  .staggerFrom(runwayChart.querySelectorAll('.details'), 0.6, getFadeUpTween(2.2), 0.15, 3)
  .from('#dashboard-backdrop-mask', 2, { scale: 0, transformOrigin: 'center', ease: Power2.easeIn, delay: 0.35 }, 3)
  .to(dashboard.querySelectorAll('.hide'), 0.3, { opacity: 1 })

// calloutTween.stop();

module.exports = calloutTween;